// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3hoTp","text":"SelectPayment_text__3tBKk","title":"SelectPayment_title__3Nbfl","btn":"SelectPayment_btn__2HuH5"};